import React, { useState } from "react";
import { APP_VERSION } from "../../../../version";

// AboutModal Component
const AboutModal = ({ isOpen, onClose }: { isOpen: boolean; onClose: () => void }) => {
  if (!isOpen) return null;

  const handleOverlayClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      e.preventDefault();
      e.stopPropagation();
      onClose();
    }
  };

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-[9999] p-4 font-sans dark:bg-darkBackground"
      onClick={handleOverlayClick}
    >
      <div
        className="bg-white rounded-lg w-full max-w-lg max-h-[90vh] flex flex-col dark:bg-darkBackground dark:text-softGray dark:border-[1px] dark:border-softGray"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="flex items-center justify-between p-5 border-b border-gray-200">
          <h2 className="text-xl font-semibold text-gray-800 dark:text-softGray">About</h2>
          <button
            onClick={onClose}
            className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-100 transition-colors dark:hover:bg-darkBackground dark:hover:opacity-50"
          >
            <svg
              className="w-5 h-5 text-gray-500 dark:text-softGray"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        {/* Content */}
        <div className="p-6 space-y-5 overflow-y-auto text-gray-600 text-sm leading-relaxed dark:text-softGray">
          <p>
            Resource Finder Agent is your everyday AI companion with enterprise-grade security, privacy, and compliance.
          </p>
          <p>
            Resource Finder Agent combines the power of large language models (LLMs) with up-to-date information from
            the web to give you better answers, greater efficiency, and new ways to be creative. For example, get quick
            summaries of the content you view online, compare products to make informed business decisions, analyze
            images, draft content, and more.
          </p>
          <div>
            <p>Get started with Copilot by asking a question or giving instructions. Or try one of these:</p>
            <ul className="list-disc list-inside mt-2 space-y-1 text-gray-500 dark:text-softGray">
              <li>Give me a summary of recent news about [product]</li>
              <li>Help me learn about [topic]</li>
              <li>How do I set achievable goals at work?</li>
            </ul>
          </div>
          <p>
            You can ask follow-up questions to fine-tune the response. AI-generated content may be incorrect, so sources
            are provided for your review when possible. Copilot data associated with your work or school account may be
            provided to your organization.
          </p>
        </div>

        {/* Footer */}
        <div className="flex items-center gap-6 p-5 border-t border-gray-200 bg-gray-50 rounded-b-lg text-center justify-center dark:bg-darkBackground dark:border-softGray">
          <p className="text-sm">Resource Finder Agent Version {APP_VERSION}</p>
        </div>
      </div>
    </div>
  );
};

export default AboutModal;
